module.exports = __webpack_public_path__ + "static/media/10a.8f2b107f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/10a.jpg
// module id = 572
// module chunks = 0